var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransferData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3101_15245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.375 0.875H2.625C2.39294 0.875 2.17038 0.967187 2.00628 1.13128C1.84219 1.29538 1.75 1.51794 1.75 1.75V3.5C1.75 3.73206 1.84219 3.95462 2.00628 4.11872C2.17038 4.28281 2.39294 4.375 2.625 4.375H6.5625V7.07438L5.42937 5.94563L4.8125 6.5625L7 8.75L9.1875 6.5625L8.57063 5.94563L7.4375 7.07438V4.375H11.375C11.6071 4.375 11.8296 4.28281 11.9937 4.11872C12.1578 3.95462 12.25 3.73206 12.25 3.5V1.75C12.25 1.51794 12.1578 1.29538 11.9937 1.13128C11.8296 0.967187 11.6071 0.875 11.375 0.875ZM2.625 1.75H4.375V3.5H2.625V1.75ZM11.375 3.5H5.25V1.75H11.375V3.5Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.375 9.625H2.625C2.39294 9.625 2.17038 9.71719 2.00628 9.88128C1.84219 10.0454 1.75 10.2679 1.75 10.5V12.25C1.75 12.4821 1.84219 12.7046 2.00628 12.8687C2.17038 13.0328 2.39294 13.125 2.625 13.125H11.375C11.6071 13.125 11.8296 13.0328 11.9937 12.8687C12.1578 12.7046 12.25 12.4821 12.25 12.25V10.5C12.25 10.2679 12.1578 10.0454 11.9937 9.88128C11.8296 9.71719 11.6071 9.625 11.375 9.625ZM2.625 10.5H8.75V12.25H2.625V10.5ZM11.375 12.25H9.625V10.5H11.375V12.25Z",
    fill: "#F4F4F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3101_15245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferData);
export default __webpack_public_path__ + "static/media/transfer-data.4102566b5040a78de1d55bea779dd927.svg";
export { ForwardRef as ReactComponent };